export const CARE_ICON_OPTIONS = [
    { key: "tv", label: "TV" },
    { key: "apps", label: "Apps / Play" },
    { key: "radio", label: "Radio" },
    { key: "info", label: "Information" },
    { key: "relatives", label: "Family" },
    { key: "wifi", label: "Wi-Fi" },
    { key: "welcome", label: "Envelope" },
    { key: "instagram", label: "Instagram" },
    { key: "weather", label: "Weather" },
    { key: "heart", label: "Heart" },
    { key: "star", label: "Star" },
    { key: "calendar", label: "Calendar" },
    { key: "clock", label: "Clock" },
    { key: "phone", label: "Phone" },
    { key: "book", label: "Book" },
    { key: "bell", label: "Bell" },
    { key: "leaf", label: "Leaf" },
    { key: "sun", label: "Sun" },
    { key: "coffee", label: "Coffee" },
    { key: "music", label: "Music" },
    { key: "house", label: "House" },
    { key: "gift", label: "Gift" },
];
